import { RootState } from "../types/store.types";

export const selectMeasureDatasets = (state: RootState) => state.measureDatasets;
